// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// AWS Cognito Configuration
export const AWS_REGION = process.env.REACT_APP_REGION;
export const USER_POOL_ID = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const USER_POOL_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;
export const REDIRECT_SIGN_IN = process.env.REACT_APP_REDIRECT_SIGN_IN;
export const REDIRECT_SIGN_OUT = process.env.REACT_APP_REDIRECT_SIGN_OUT;
// Environment
export const STAGE = process.env.REACT_APP_STAGE;